export const InventoryEventSymbol = Symbol('inventoryEvent');
